export const Constants = {
    KEY: "key",
    MASTER_ADDRESS: "master_address",
    ADDRESS: "address",
    BALANCE: "balance",
    CURRENCY_CODE: "currency_code",
    SEND_ADDRESS: "send_address"
}